import { useCallback, useEffect, useRef } from 'react';
import queryString from 'query-string';
import type { Location, HistoryAction } from '@atlassian/react-resource-router';
import { QUERY_PARAM_SELECTED_ISSUE } from '../../model/routing/constants.tsx';
import type { CardId, CardKey } from '../../model/types.tsx';

export type PropsWithoutRouter = {
	lastSelectedCardId: CardId | null;
	setLastSelectedCardKey: (cardKey: CardKey) => void;
	setAllPanels: () => void;
	isCompanyManaged?: boolean;
};

export type Props = {
	action: HistoryAction;
	location: Location;
} & PropsWithoutRouter;

export const SyncWithRouting = (props: Props) => {
	const {
		action,
		location,
		lastSelectedCardId,
		setLastSelectedCardKey,
		setAllPanels,
		isCompanyManaged = false,
	} = props;

	const update = useCallback(() => {
		const { search } = location;
		const searchParams = queryString.parse(search);

		if (!isCompanyManaged) {
			setAllPanels();
		}

		// Update Selected Card Key
		const selectedCardKeyFromParams = searchParams[QUERY_PARAM_SELECTED_ISSUE];
		if (!lastSelectedCardId && selectedCardKeyFromParams) {
			setLastSelectedCardKey(selectedCardKeyFromParams);
		}
	}, [location, lastSelectedCardId, setLastSelectedCardKey, setAllPanels, isCompanyManaged]);

	const isMounted = useRef(false);
	useEffect(() => {
		if (!isMounted.current) {
			update();
			isMounted.current = true;
		}
	}, [update, isMounted]);
	const loc = useRef(location);
	useEffect(() => {
		if (action === 'POP' && loc.current !== location) {
			update();
		}
		loc.current = location;
	}, [action, location, update]);

	return null;
};
